<template>
  <router-view />
</template>

<script>
export default {
  name: "SalesConfig"
};
</script>

<style></style>
